DialogController = App.loadClass 'core::Angular/DialogController'

class exports.BinDetailsController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @modal, @service, $q, @bin, @noSave) ->
        super

        unless @bin.$save?
            @bin = new @service.StorageLocation @bin

        @scope.title = 'Bin Details'

        # Get fans
        if @bin.id?
            @service.StorageFan.query binId: @bin.id
            .$promise.then (@fans) =>
                @_recalcMaxFanNumber()
        else if @bin.fans?.length # for grower create
            @fans = @bin.fans
            @_recalcMaxFanNumber()
        else
            @fans = []
            @maxFanNumber = 0

        @binToTruckUnloads = [
            'Auger'
            'Belt'
            'Conveyor'
            'Elevator'
        ]
        @ladderTypes = [
            'Ladder w/o Platform'
            'Ladder w/ Platform'
            'Stairs'
            'None'
        ]
        @inspectionSafeties = [
            'Good'
            'Fair'
            'Poor'
        ]
        @sensorTypes = [
            'Moisture'
            'Temperature'
        ]
        @fanTypes = [
            'Centrifugal'
            'Axial Vane'
        ]

        @scope.save = () =>
            if @scope.form.$invalid
                for idx in [0...@fans.length]
                    fan = @scope.form.fanForms[idx]
                    fan.rpm.$setDirty()
                    fan.horse_power.$setDirty()
                    fan.type.$setDirty()
            if @noSave # basically: on grower
                @bin.fans = @fans
                if @scope.form.$invalid
                    return $q.resolve()
                @modalInstance.close @bin
                return

            @bin.$update()
            .then () =>
                fanPromises = @fans.map (fan) ->
                    return if fan.id? then fan.$update() else fan.$save()
                $q.all fanPromises
                .then () =>
                    @modalInstance.close()
            .catch (err) ->
                throw err

    addFan: () ->
        @fans.push new @service.StorageFan
            fan_number: ++@maxFanNumber
            storage_locations_id: @bin.id

    deleteFan: (fan) ->
        unless fan.id?
            @fans.splice @fans.indexOf(fan), 1
            @_recalcMaxFanNumber()
            return
        newscope = @scope.$new()
        newscope.title = 'Delete Fan'
        newscope.item_name = 'Fan'
        newscope.delete = () =>
            fan.$delete()
            .then () =>
                @fans.splice @fans.indexOf(fan), 1
                @_recalcMaxFanNumber()

        @modal.open
            templateUrl: 'backend/portal/home/delete-dialog'
            controller: 'DeleteDialogController'
            scope: newscope

    validateVolume: () ->
        return true if not @bin.eave_height? or not @bin.floor_height?
        return (@bin.eave_height - @bin.floor_height / 12) > 0

    _recalcMaxFanNumber: () ->
        @maxFanNumber = @fans.map (fan) ->
            return fan.fan_number
        .reduce (fan1, fan2) ->
            return Math.max fan1, fan2
        , 0
